import React, { Component } from 'react';
import Radium from 'radium';

import Header from "./Header";

import TextField from './TextField';
import Button from './Button';
import Error from "./Error";
import UserServices from '../services/UserServices';

class Login extends Component {

	constructor(props) {
		super(props);
		this.state = {
			email: "",
			password: ""
		};
	}

	async onLoginOrRegister() {
		this.setState({
			error: null
		});

		if (this.isLoginPage()) {
			this.onLogin();
		} else {
			this.onRegister();
		}
	}

	async onLogin() {
		if (this.state.email.length > 0 && this.state.password.length > 0) {
			try {
				await UserServices.login(this.state.email, this.state.password);
				window.location.href = "/";
			} catch (e) {
				console.error(e);
				this.setState({
					error: e
				});
			}
		}
	}

	async onRegister() {
		if (this.state.email.length > 0 && this.state.password.length > 0) {
			try {
				await UserServices.register(this.state.email, this.state.password);
				window.location.href = "/";
			} catch (e) {
				console.error(e);
				this.setState({
					error: e
				});
			}
		}
	}

	onChangeField(field, value, lowercase) {
		var updateObj = {};

		if (lowercase) {
			updateObj[field] = value.toLowerCase();
		} else {
			updateObj[field] = value;
		}
		
		this.setState(updateObj);
	}

	isLoginPage() {
		if (window.location.href.indexOf("login") >= 0) {
			return true;
		} else {
			return false;
		}
	}

	getTitle() {
		if (this.isLoginPage()) {
			return "Login";
		} else {
			return "Register";
		}
	}

	getOrDescription() {
		if (this.isLoginPage()) {
			return "Or Register";
		} else {
			return "Or Login";
		}
	}

	onOr() {
		if (this.isLoginPage()) {
			window.location.href = "/register";
		} else {
			window.location.href = "/login";
		}
	}

	render() {
		return (
			<div style={this.localStyles().container}>
				<Header style={this.props.style}/>
				<div style={this.localStyles().content}>
					<div style={this.props.style.global.h1}>{this.getTitle()}</div>
					<Error 
						style={this.props.style}
						error={this.state.error}/>
					<div style={this.localStyles().inputFields}>
						<TextField 
							type="text" 
							value={this.state.email}
							label="Email" 
							placeholder="Email"
							onEnter={() => this.onLogin}
							style={this.props.style}
							onChange={(val) => this.onChangeField("email", val, true)}/>

						<TextField 
							type="password" 
							value={this.state.password}
							label="Password" 
							placeholder="Password"
							style={this.props.style}
							onEnter={() => this.onLogin()}
							onChange={(val) => this.onChangeField("password", val)}/>

						<Button 
							style={this.props.style}
							title={this.getTitle()}
							marginTop={40}
							disabled={this.state.email === "" || this.state.password === ""}
							onClick={() => this.onLoginOrRegister()}/>
					
						<div style={this.localStyles().or} onClick={() => this.onOr()}>
							{this.getOrDescription()}
						</div>

					</div>
				</div>
			</div>
		)
	}

	localStyles() {
		return {
			container: {
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				width: "100%"
			},
			content: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column",
				maxWidth: 400,
				width: "80%"
			},
			or: {
				color: this.props.style.colors.lightText,
				opacity: 0.6,
				cursor: "pointer",
				alignItems: "center",
				flex: 1,
				display: "flex",
				justifyContent: "center",
				fontWeight: 700,
				fontSize: 14,
				transition: "all 0.2s ease-in-out",
				":hover": {
					color: this.props.style.colors.primary,
					opacity: 1
				}
			},
			inputFields: {
				marginTop: 50,
				width: "100%"
			}
		}
	}
}

export default Radium(Login);


// WEBPACK FOOTER //
// ./src/components/Login.js